import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "checkout-confirm-icon",
  xmlns: "http://www.w3.org/1999/xlink"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.78 5.67L1.26 3.15 0 4.41l2.52 2.51 1.26 1.26 1.26-1.26 5.66-5.66L9.44 0 3.78 5.67z"
}, null, -1);
const _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}